import {
  FascicoloRicorsoGerarchico
} from '../../../../amministrativa/fascicoloFormShared/models/ricorso-gerarchico/fascicolo-ricorsogerarchico';
import {
  FormRevocazioneViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-revocazione/view/form-revocazione-view.component';
import {
  FormRicorsoGerarchicoViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-gerarchico/view/form-ricorso-gerarchico-view.component';
import {
  FormRicorsoStraordinarioPresidenterepViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-straordinario-presidenterep/view/form-ricorso-straordinario-presidenterep-view.component';
import {
  FormRicorsoGerarchicoComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-gerarchico/form-ricorso-gerarchico.component';
import {
  FormOpposizioneDiTerzoComponent
} from '../../../../amministrativa/fascicoloFormShared/form-opposizione-di-terzo/form-opposizione-di-terzo.component';
import {
  FascicoloRevocazione
} from '../../../../amministrativa/fascicoloFormShared/models/revocazione/fascicolo-revocazione';
import {
  FormOpposizioneDiTerzoViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-opposizione-di-terzo/view/form-opposizione-di-terzo-view.component';
import {
  FascicoloRicorsoStraordinarioPresidenteRep
} from '../../../../amministrativa/fascicoloFormShared/models/ricorso-straordinario-presidenterep/fascicolo-ricorsostraordinario-presidenterep';
import {
  FormRevocazioneComponent
} from '../../../../amministrativa/fascicoloFormShared/form-revocazione/form-revocazione.component';
import {
  FascicoloOpposizioneDiTerzo
} from '../../../../amministrativa/fascicoloFormShared/models/opposizione-di-terzo/fascicolo-opposizione-di-terzo';
import {
  FormRicorsoStraordinarioPresidenterepComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-straordinario-presidenterep/form-ricorso-straordinario-presidenterep.component';
import {
  FormRicorsoOpposizioneViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-opposizione/view/form-ricorso-opposizione-view.component';
import {
  FormRicorsoOpposizioneComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-opposizione/form-ricorso-opposizione.component';
import {FormAppelloComponent} from '../../../../amministrativa/fascicoloFormShared/form-appello/form-appello.component';
import {
  FormAppelloViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-appello/view/form-appello-view.component';
import {
  FormRicorsoAmministrativoViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso/view/form-ricorso-view.component';
import {
  FormRicorsoAmministrativoComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso/form-ricorso.component';
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component';
import {
  FormRecuperoCreditiStragiudizialeComponent
} from '../../../../amministrativa/fascicoloFormShared/form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import {
  FormOrdinarioViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ordinario/view/form-ordinario-view.component';
import {
  FormOrdinarioComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ordinario/form-ordinario.component';
import {
  FormSpecialeComponent
} from '../../../../amministrativa/fascicoloFormShared/form-speciale/form-speciale.component';
import {
  FormSpecialeViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-speciale/view/form-speciale-view.component';
import {
  FormRicorsoLavoroViewComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-lavoro/view/form-ricorso-lavoro-view.component';
import {
  FormRicorsoLavoroComponent
} from '../../../../amministrativa/fascicoloFormShared/form-ricorso-lavoro/form-ricorso-lavoro.component';
import {
  FascicoloRicorsoOpposizione
} from '../../../../amministrativa/fascicoloFormShared/models/ricorso-opposizione/fascicolo-ricorso-opposizione';
import {FascicoloAppello} from '../../../../amministrativa/fascicoloFormShared/models/appello/fascicolo-appello';
import {
  FascicoloRicorsoAmministrativo
} from '../../../../amministrativa/fascicoloFormShared/models/ricorso/fascicolo-ricorso';
import {
  FascicoloRecuperoCreditiStragiudiziale
} from '../../../../amministrativa/fascicoloFormShared/models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale';
import {FascicoloOrdinario} from '../../../../amministrativa/fascicoloFormShared/models/ordinario/fascicolo-ordinario';
import {FascicoloSpeciale} from '../../../../amministrativa/fascicoloFormShared/models/speciale/fascicolo-speciale';
import {
  FascicoloRicorsoLavoro
} from '../../../../amministrativa/fascicoloFormShared/models/ricorso-lavoro/fascicolo-ricorso-lavoro';
import { FormGenericoViewComponent } from 'src/app/amministrativa/fascicoloFormShared/form-generico/view/form-generico-view.component';
import { FormGenericoComponent } from 'src/app/amministrativa/fascicoloFormShared/form-generico/form-generico.component';
import { FascicoloGenerico } from 'src/app/amministrativa/fascicoloFormShared/models/generico/fascicolo-generico';


export function getComponentFromFormTenantAministrativa(idFormTenant, view = false) {
  switch (idFormTenant) {
    case 'AmmRsp_PRD': {
      // "RICORSO STRAORDINARIO AL PRESIDENTE DELLA REPUBBLICA"
      return view ? FormRicorsoStraordinarioPresidenterepViewComponent : FormRicorsoStraordinarioPresidenterepComponent;
    }
    case 'AmmRge_PRD': {
      return view ? FormRicorsoGerarchicoViewComponent : FormRicorsoGerarchicoComponent; // "RICORSO GERARCHICO",
    }
    case 'AmmRop_PRD': {
      return view ? FormRicorsoOpposizioneViewComponent : FormRicorsoOpposizioneComponent; // "RICORSO IN OPPOSIZIONE",
    }
    case 'AmmApp_PRD': {
      return view ? FormAppelloViewComponent : FormAppelloComponent; // "APPELLO",
    }
    case 'AmmRev_PRD': {
      return view ? FormRevocazioneViewComponent : FormRevocazioneComponent; // "REVOCAZIONE",
    }
    case 'AmmOdt_PRD': {
      return view ? FormOpposizioneDiTerzoViewComponent : FormOpposizioneDiTerzoComponent; // "OPPOSIZIONE DI TERZO",
    }
    case 'AmmRat_PRD': {
      // "RICORSO AMMINISTRRATIVO"
      return view ? FormRicorsoAmministrativoViewComponent : FormRicorsoAmministrativoComponent;
    }
    case 'AmmRec_PRD': {
      // "RECUPERO CREDITI STRAGIUDIZIALE"
      return view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent;
    }
    case 'AmmOrd_PRD': {
      return view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO";
    }
    case 'AmmSpe_PRD': {
      return view ? FormSpecialeViewComponent : FormSpecialeComponent; // "SPECIALE";
    }
    case 'AmmRic_PRD': {
      return view ? FormRicorsoLavoroViewComponent : FormRicorsoLavoroComponent; // "RICORSO";
    }
    case 'AmmGen_PRD': {
      return view ? FormGenericoViewComponent : FormGenericoComponent;
    }
  }
}

export function getFascicoloAmministrativo(genericFascicolo): any {
  switch (genericFascicolo) {
    case 'ricorsostraordinariopresidente': {
      return new FascicoloRicorsoStraordinarioPresidenteRep();
    }
    case 'ricorsogerarchico': {
      return new FascicoloRicorsoGerarchico();
    }
    case 'ricorsoopposizione': {
      return new FascicoloRicorsoOpposizione();
    }
    case 'appello': {
      return new FascicoloAppello();
    }
    case 'revocazione': {
      return new FascicoloRevocazione();
    }
    case 'opposizionediterzo': {
      return new FascicoloOpposizioneDiTerzo();
    }
    case 'ricorsoamministrativo':
    case 'ricorsotar': {
      return new FascicoloRicorsoAmministrativo();
    }
    case 'recuperocreditistragiudiziale': {
      return new FascicoloRecuperoCreditiStragiudiziale();
    }
    case 'ordinario': {
      return new FascicoloOrdinario();
    }
    case 'speciale': {
      return new FascicoloSpeciale();
    }
    case 'ricorso':
    case 'ricorsolavoro': {
      return new FascicoloRicorsoLavoro();
    }
    case 'genericogiudiziale': {
      return new FascicoloGenerico();
    }
  }
}
